module.exports = __webpack_public_path__ + "static/media/laura.4b62fed9.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/laura.JPG
// module id = 723
// module chunks = 0